import axios from "axios";
import http from "@/utils/request";
import { httpUpload } from "@/utils/request";
// 请求 
export const Get_wx_sign = (params) => {
    const http1 = axios.create({
        baseURL: "/api",
        // 设置区分开发与生产环境url
        //baseURL: process.env.NODE_ENV === "development" ? "/api" : baseURL,
        timeout: 10000,
    });
    http1.interceptors.request.use(function (config) {
        config.headers['Content-Type'] = 'application/json;charset=utf-8';
        config.withCredentials = true; // 允许携带cookie
        return config;
    }, function (error) {
        return Promise.reject(error);
    });
    http1.interceptors.response.use(
        response => {
            let res = response.data;
            if (typeof res === 'string') {
                res = res ? JSON.parse(res) : res
            }
            return res;
        },
        error => {
            console.log('err' + error) // for debug
            return Promise.reject(error)
        });

    return http1.get("/Cust_info/Get_wx_sign", params);
};

//保持 wx 圖片
export const Save_wx_photo = (params) => {
    // 返回一个promise对象
    return http.get("/Cust_info/Save_wx_photo", params);
};
//讀取已保存的圖片
export const Get_wx_photo = (params) => {
    const http1 = axios.create({
        baseURL: "/api",
        // 设置区分开发与生产环境url
        //baseURL: process.env.NODE_ENV === "development" ? "/api" : baseURL,
        timeout: 10000,
    });
    http1.interceptors.request.use(function (config) {
        config.headers['Content-Type'] = 'application/json;charset=utf-8';
        config.withCredentials = true; // 允许携带cookie
        return config;
    }, function (error) {
        return Promise.reject(error);
    });
    http1.interceptors.response.use(
        response => {
            let res = response.data;
            if (typeof res === 'string') {
                res = res ? JSON.parse(res) : res
            }
            return res;
        },
        error => {
            console.log('err' + error) // for debug
            return Promise.reject(error)
        });

    return http1.get("/Cust_info/Get_wx_photo", params);
};

//保存 input file 選擇的圖片
export const Save_photo = (data) => {
    return httpUpload.post("/FileUpload/FormSingleFileUpload", data);
};

export const Save_Image = (data) => {
    return httpUpload.post("/FileUpload/EditorFileUpload", data);
};
